import React, { useState, useEffect, useRef } from "react";
import {
  ERROR_CODES,
  LOGIN_TYPE_LIAISON_OFFICER,
} from "../../utils/errorConstants";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import { useParams } from "react-router";

const REG = /^[0-9]$/;

const OtpInput = ({
  creds,
  otp,
  panCard,
  setOtpMsg,
  setPanError,
  onChange,
  error,
  errorMsg,
  setOtpError,
  handleContinue,
}) => {
  const [password, setPassword] = useState({
    pass1: "",
    pass2: "",
    pass3: "",
    pass4: "",
    pass5: "",
    pass6: "",
  });

  const [deleteSteps, setDeleteSteps] = useState({
    pass1: 0,
    pass2: 0,
    pass3: 0,
    pass4: 0,
    pass5: 0,
    pass6: 0,
  });

  const pass1Ref = useRef("");
  const pass2Ref = useRef("");
  const pass3Ref = useRef("");
  const pass4Ref = useRef("");
  const pass5Ref = useRef("");
  const pass6Ref = useRef("");
  const inputPass1Ref = useRef();

  const [counter, setCounter] = useState(60);
  const myInterval = useRef();
  const { type } = useParams();

  useEffect(() => {
    if (
      password?.pass1 &&
      password?.pass2 &&
      password?.pass3 &&
      password?.pass4 &&
      password?.pass5 &&
      password?.pass6
    ) {
      setOtpError({
        state: false,
        message: "",
      });
    } else {
      setOtpError({
        state: true,
        message: "",
      });
    }
  }, [
    password.pass1,
    password.pass2,
    password.pass3,
    password.pass4,
    password.pass5,
    password.pass6,
    setOtpError,
  ]);

  useEffect(() => {
    inputPass1Ref.current.focus();
    return () => clearInterval(myInterval.current);
  }, []);

  useEffect(() => {
    if (counter === -1) {
      clearInterval(myInterval.current);
      myInterval.current = null;
    }
    if (counter === 60) {
      myInterval.current = setInterval(
        () => setCounter((counter) => counter - 1),
        1000,
      );
    }
  }, [counter]);

  const handleChange = (e, nextId, prev) => {
    const { name, value } = e.target;
    if (REG.test(e.target.value)) {
      setPassword({ ...password, [name]: value });
      setPassword((password) => {
        onChange([...Object.values(password)].join(""));
        return password;
      });
      setDeleteSteps({ ...deleteSteps, [name]: 0 });
    } // THIS WILL GET THE VALUE

    if (REG.test(e.target.value) && e.target.value.length !== 0) {
      setDeleteSteps({ ...deleteSteps, [name]: 0 });
      document.getElementById(`pass${nextId}`).focus();
    }

    if (value.length === 0) {
      setPassword({ ...password, [name]: value });
      setDeleteSteps({ ...deleteSteps, [name]: deleteSteps[name] + 1 });
    }
  };
  const handleName = (e, prev, next) => {
    const { name } = e.target;
    if (e.key === "Backspace" && (deleteSteps[name] === 1 || !e.target.value)) {
      document.getElementById(`pass${prev}`).focus();
    }
  };

  useEffect(() => {
    pass1Ref.current = password.pass1;
    pass2Ref.current = password.pass2;
    pass3Ref.current = password.pass3;
    pass4Ref.current = password.pass4;
    pass5Ref.current = password.pass5;
    pass6Ref.current = password.pass6;
  }, [password]);

  const handleResendOtp = () => {
    setCounter(60);
    if (type !== LOGIN_TYPE_LIAISON_OFFICER) {
      // 'type' is derived from URL params:
      // - For Client Login (root route "/"), 'type' is undefined
      // - In other cases (Client Login or Family Office Team Login),
      //   it can have values like "user" or "family-office-team"
      AuthStore._clientGenerateOtp(panCard, {
        onSuccess: (data) => {
          UserStore.setSessionId(data.sessionId);
          setOtpMsg(data.statusMessage);
        },
        onFail: (error) => {
          setPanError({
            state: true,
            message: ERROR_CODES[error.statusCode] || error.statusMessage,
          });
        },
      });
    } else {
      AuthStore._liasionOfficerGenerateOtp(
        {
          MobileNo: creds.mobileNumber,
          EmailId: creds.emailAddress,
        },
        {
          onSuccess: (data) => {
            UserStore.setSessionId(data.sessionId);
            setOtpMsg(data.statusMessage);
            //  AuthStore.updateLoadingForLogin(false);
          },
          onFail: (error) => {
            // AuthStore.updateLoadingForLogin(false);
            setPanError({
              state: true,
              message: ERROR_CODES[error.statusCode] || error.statusMessage,
            });
          },
        },
      );
    }
  };

  useEffect(() => {
    if (otp?.length === 6) {
      handleContinue();
    }
    // eslint-disable-next-line
  }, [otp]);

  return (
    <div>
      <div className="label_div">
        <span className="enter_otp_label">Enter OTP</span>
      </div>

      <div className="pass_div">
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass1"}
          className="ip_pass1 ip_margin"
          name={"pass1"}
          value={password.pass1}
          ref={inputPass1Ref}
          onChange={(e) => handleChange(e, 2, 1)}
          onKeyDown={(e) => handleName(e, 1, 2)}
          autoComplete={"off"}
          inputmode="decimal"
        />
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass2"}
          className="ip_pass1 ip_margin"
          name={"pass2"}
          value={password.pass2}
          onChange={(e) => handleChange(e, 3, 1)}
          autoComplete={"off"}
          onKeyDown={(e) => handleName(e, 1, 3)}
          inputmode="decimal"
        />
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass3"}
          className="ip_pass1 ip_margin"
          name={"pass3"}
          value={password.pass3}
          onChange={(e) => handleChange(e, 4, 2)}
          autoComplete={"off"}
          onKeyDown={(e) => handleName(e, 2, 4)}
          inputmode="decimal"
        />
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass4"}
          className="ip_pass1 ip_margin"
          name={"pass4"}
          value={password.pass4}
          onChange={(e) => handleChange(e, 5, 3)}
          autoComplete={"off"}
          onKeyDown={(e) => handleName(e, 3, 5)}
          inputmode="decimal"
        />
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass5"}
          className="ip_pass1 ip_margin"
          name={"pass5"}
          value={password.pass5}
          onChange={(e) => handleChange(e, 6, 4)}
          autoComplete={"off"}
          onKeyDown={(e) => handleName(e, 4, 6)}
          inputmode="decimal"
        />
        <input
          type="text"
          pattern="\d*"
          inputMode="numaric"
          id={"pass6"}
          className="ip_pass1"
          name={"pass6"}
          value={password.pass6}
          onChange={(e) => handleChange(e, 6, 5)}
          autoComplete={"off"}
          onKeyDown={(e) => handleName(e, 5, 6)}
          inputmode="decimal"
        />
      </div>

      <div aria-live="assertive" className="error_div3">
        {error && errorMsg}
      </div>
      <div>
        {counter >= 0 ? (
          <>
            <span className="resend_otp">Resend OTP in</span>
            <span className="seconds">
              {" "}
              {`${counter < 0 ? 0 : counter} secs`}
            </span>
          </>
        ) : (
          <span className="resend_otp_text" onClick={handleResendOtp}>
            Resend OTP
          </span>
        )}
      </div>
    </div>
  );
};

export default OtpInput;
